"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var element_1 = require("../element");
var geometry_1 = require("../geometry");
var component_1 = require("./component");
var Gene = /** @class */ (function (_super) {
    __extends(Gene, _super);
    function Gene() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._promoterLength = 0;
        return _this;
    }
    Gene.prototype.defaultOptions = function () {
        return {
            _displayPromoter: false,
            _labelPosition: GeneLabelPosition.Right,
            _intronHeight: 3,
            _geneHeight: 9,
            _height: 0,
        };
    };
    Gene.prototype.init = function () {
        var _this = this;
        this._promoter = this.appendT(element_1.Rect).options({
            _anchor: 64 /* Right */ | 4 /* Middle */,
            _x: 0,
            _y: 0,
            _width: function (_) { return _this._promoterLength; },
            _height: function () { return _this._intronHeight; },
            visibility: function (d, i, g, h) { return _this.getOption("_displayPromoter") ? "visible" : "hidden"; },
            fill: "#ffffff",
        });
        this._terminator = this.appendT(element_1.Rect).options({
            _anchor: 16 /* Left */ | 4 /* Middle */,
            _x: function (d) { return _this.scale(d.end) - _this.scale(d.start); },
            _y: 0,
            _width: function (_) { return _this._promoterLength; },
            _height: function () { return _this._intronHeight; },
            visibility: function (d, i, g, h) { return h.parOp("_displayPromoter") ? "visible" : "hidden"; },
            fill: "#ffffff",
        });
        this._intronLine = this.appendT(element_1.Rect).options({
            _anchor: 16 /* Left */ | 4 /* Middle */,
            _x: 0,
            _y: 0,
            _width: function (d) { return _this.scale(d.end) - _this.scale(d.start); },
            _height: function () { return _this._intronHeight; },
            fill: "#ffbb4d",
        });
        this._exons = this.appendGroupT(element_1.Rect).options({
            _anchor: 16 /* Left */ | 4 /* Middle */,
            _x: function (d) { return _this.scale(d.start) - _this.scale(d.geneStart); },
            _y: 0,
            _width: function (d) {
                var width = _this.scale(d.start + d.len) - _this.scale(d.start);
                return width > 1 ? width : 1;
            },
            _height: function (d, i, g, h) { return _this._geneHeight; },
            fill: "#ffbb4d",
            _data: function (d) {
                var ex = d.exons.slice();
                // add gene start pos in exon data
                ex.forEach(function (x) { x.geneStart = d.start; x.color = d.color; x._gene = d; });
                return ex;
            },
        });
        this._label = this.appendT(element_1.Text).options({
            _anchor: function (d) {
                switch (_this._labelPosition) {
                    case GeneLabelPosition.Bottom:
                        return 16 /* Left */ | 2 /* Top */;
                    case GeneLabelPosition.Top:
                        return 16 /* Left */ | 8 /* Bottom */;
                    default:
                        return 16 /* Left */ | 4 /* Middle */;
                }
            },
            _x: function (d) {
                switch (_this._labelPosition) {
                    case GeneLabelPosition.Right:
                        return _this.scale(d.end) - _this.scale(d.start) + 5;
                    case GeneLabelPosition.Bottom:
                    case GeneLabelPosition.Top:
                        return 0;
                    case GeneLabelPosition.Inside:
                        return 5;
                    default: return 0;
                }
            },
            _y: function (d) {
                switch (_this._labelPosition) {
                    case GeneLabelPosition.Right:
                    case GeneLabelPosition.Inside:
                        return 0;
                    case GeneLabelPosition.Bottom:
                        return _this._geneHeight + 2;
                    case GeneLabelPosition.Top:
                        return -2;
                    default: return 0;
                }
            },
            _text: function (d) { return d.name; },
            visibility: function (d) { return _this._labelPosition === GeneLabelPosition.None ? "hidden" : "visible"; },
            "font-size": 10,
        });
    };
    Gene.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        this.scale = this.getOption("_scale");
        this._labelPosition = this.getOption("_labelPosition");
        this._geneHeight = this.getOption("_geneHeight");
        this._intronHeight = this.getOption("_intronHeight");
        this._promoterLength = this.scale(2000);
        if (this._promoterLength < 1) {
            this._promoterLength = 1;
        }
        var proxyDict = {
            exons: "_exons",
            introns: "_intronLine",
            label: "_label",
            promoter: "_promoter",
            terminator: "_terminator",
        };
        if (this.parent instanceof GeneArea) {
            this.parent.setupProxy(proxyDict, this);
        }
        else {
            this.setupProxy(proxyDict);
        }
    };
    return Gene;
}(component_1.Component));
exports.Gene = Gene;
var GeneLabelPosition;
(function (GeneLabelPosition) {
    GeneLabelPosition["Top"] = "top";
    GeneLabelPosition["Right"] = "right";
    GeneLabelPosition["Bottom"] = "bottom";
    GeneLabelPosition["Inside"] = "inside";
    GeneLabelPosition["None"] = "none";
})(GeneLabelPosition = exports.GeneLabelPosition || (exports.GeneLabelPosition = {}));
var GeneAreaMode;
(function (GeneAreaMode) {
    GeneAreaMode[GeneAreaMode["Merged"] = 0] = "Merged";
    GeneAreaMode[GeneAreaMode["Packed"] = 1] = "Packed";
    GeneAreaMode[GeneAreaMode["Full"] = 2] = "Full";
})(GeneAreaMode = exports.GeneAreaMode || (exports.GeneAreaMode = {}));
var GeneArea = /** @class */ (function (_super) {
    __extends(GeneArea, _super);
    function GeneArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supportsGroup = false;
        _this.hasFlexibleSize = true;
        _this.hasFixedSize = false;
        return _this;
    }
    GeneArea.prototype.defaultOptions = function () {
        return {
            _rowHeight: 15,
            _geneHeight: 9,
            _intronHeight: 3,
            _geneColor: "#ffbb4d",
            _labelColor: "#aaa",
            _labelSize: 9,
            _labelPosition: GeneLabelPosition.Right,
            _xPadding: 0,
            _mode: GeneAreaMode.Packed,
            _mergeTranscripts: false,
            _dataKey: null,
            _verticallyFlipped: false,
        };
    };
    GeneArea.prototype.init = function () {
        var _this = this;
        this.genes = this.appendGroupT(Gene).options({
            _x: function (d) { return _this._scale(d.start); },
        });
    };
    GeneArea.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        this._scale = this.getOption("_scale");
        this._rowHeight = this.getOption("_rowHeight");
        this._verticallyFlipped = this.getOption("_verticallyFlipped");
        var xPadding = this.getOption("_xPadding");
        this.genes.options("_y", this._verticallyFlipped ?
            function (d) { return ({
                unit: geometry_1.GeometryUnit.Percent,
                value: 100,
                offset: d.row * -_this._rowHeight - _this._rowHeight / 2 - xPadding
            }); } :
            function (d) { return d.row * _this._rowHeight + _this._rowHeight / 2 + xPadding; });
        this.processData();
        this.updateLayerMode();
        this.genes.options({
            _scale: this._scale,
            _scale_isFunc: false,
        });
        this.genes.data(this.mergedData);
        this.setupProxy({
            gene: "genes",
        });
    };
    GeneArea.prototype.postOptionsUpdate = function (dirtyOptions) {
        var _this = this;
        ["_geneHeight", "_intronHeight", "_geneColor", "_labelColor", "_labelSize", "_labelPosition"].forEach(function (op) {
            if (dirtyOptions.has(op)) {
                _this.genes.options(op, _this.getOption(op));
            }
        });
        if (dirtyOptions.has("_mergeTranscripts")) {
            this.processData();
        }
    };
    GeneArea.prototype.processData = function () {
        var _this = this;
        if (!this.datumExists()) {
            return;
        }
        var data = this.getDatum().sort(function (a, b) { return a.end - b.end; });
        if (this.getOption("_mergeTranscripts")) {
            this.mergedData = [];
            var groups = _.groupBy(data, function (x) { return x.gene_name; });
            var _loop_1 = function (key) {
                var genes = groups[key];
                // copy first gene
                var currDataGene = __assign({}, genes[0]);
                currDataGene.full_name = currDataGene.name = currDataGene.gene_name;
                // merge start, end
                for (var _i = 0, genes_1 = genes; _i < genes_1.length; _i++) {
                    var gene = genes_1[_i];
                    if (gene.start < currDataGene.start) {
                        currDataGene.start = gene.start;
                    }
                    if (gene.end > currDataGene.end) {
                        currDataGene.end = gene.end;
                    }
                }
                // merge cds_regions, exons, exon_amount
                ["cds_regions", "exons"].forEach(function (attr) {
                    var intervals = genes.reduce(function (p, c) { return c[attr].concat(p); }, []);
                    intervals.forEach(function (x) { return x.end = x.start + x.len; });
                    currDataGene[attr] = _this.mergeIntervals(intervals);
                });
                currDataGene.exon_amount = currDataGene.exons.length;
                // mark as merged
                currDataGene.isMerged = true;
                this_1.mergedData.push(currDataGene);
            };
            var this_1 = this;
            // merge genes
            for (var _i = 0, _a = Object.keys(groups); _i < _a.length; _i++) {
                var key = _a[_i];
                _loop_1(key);
            }
        }
        else {
            this.mergedData = data;
        }
    };
    GeneArea.prototype.updateLayerMode = function () {
        var mode = this.getOption("_mode");
        if (typeof mode === "string") {
            mode = { merged: GeneAreaMode.Merged, packed: GeneAreaMode.Packed, full: GeneAreaMode.Full }[mode.toLowerCase()];
        }
        var scale = this.getOption("_scale");
        var invertScale = scale.invert;
        var charWidth = invertScale(5) - invertScale(0);
        var rows = [];
        var rowHeight = this.getOption("_rowHeight");
        var geneHeight = this.getOption("_geneHeight");
        var intronHeight = this.getOption("_intronHeight");
        var xPadding = this.getOption("_xPadding");
        var maxRow;
        if (mode === GeneAreaMode.Full) {
            var currentRow = -1;
            for (var _i = 0, _a = this.mergedData; _i < _a.length; _i++) {
                var gene = _a[_i];
                currentRow += 1;
                rows[currentRow] = gene.end;
                gene.row = currentRow;
            }
            maxRow = rows.length;
        }
        else if (mode === GeneAreaMode.Packed) {
            for (var _b = 0, _c = this.mergedData; _b < _c.length; _b++) {
                var gene = _c[_b];
                var geneEnd = gene.end + (gene.name.length + 2) * charWidth;
                var ableToPlace = false;
                for (var i = 0; i < rows.length; i++) {
                    if (rows[i] < gene.start) {
                        rows[i] = geneEnd;
                        gene.row = i;
                        ableToPlace = true;
                        break;
                    }
                }
                if (!ableToPlace) {
                    gene.row = rows.length;
                    rows.push(geneEnd);
                }
            }
            maxRow = rows.length;
        }
        else if (mode === GeneAreaMode.Merged) {
            for (var _d = 0, _e = this.mergedData; _d < _e.length; _d++) {
                var gene = _e[_d];
                gene.row = 0;
            }
            maxRow = 1;
        }
        this.setDynamicSize({ height: rowHeight * (maxRow) + xPadding * 2 });
        if (mode === GeneAreaMode.Merged) {
            this.genes.options("_labelPosition", GeneLabelPosition.None);
        }
        else {
            this.genes.options("_labelPosition", this.getOption("_labelPosition"));
        }
        this.currentHeight = rows.length * rowHeight + 30;
    };
    GeneArea.prototype.getDatum = function () {
        var key = this.getOption("_dataKey");
        if (typeof key === "string") {
            return this.datum[key];
        }
        return this.datum;
    };
    GeneArea.prototype.datumExists = function () {
        return !this.datum.__empty__;
    };
    GeneArea.prototype.mergeIntervals = function (intervals) {
        var merged = [];
        intervals = intervals.sort(function (a, b) { return a.start - b.start; });
        for (var _i = 0, intervals_1 = intervals; _i < intervals_1.length; _i++) {
            var interval = intervals_1[_i];
            if (merged[0] && interval.start < merged[0].end) {
                merged[0].end = interval.end;
            }
            else {
                merged.unshift(interval);
            }
        }
        merged.forEach(function (x) { x.len = x.end - x.start; });
        return merged;
    };
    return GeneArea;
}(component_1.Component));
exports.GeneArea = GeneArea;
//# sourceMappingURL=gene.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/gene.js
// module id = 1143
// module chunks = 0 1